import { Box, Button } from "@mantine/core";
import { ExclamationMarkIcon } from "@phosphor-icons/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { StateCard } from "./components/molecules";
import classes from "./states.module.css";

interface State {
  hasError: boolean;
}

const basePath = () => (window as any).__BASE_PATH__ || "";

// Canvas 3.6 «Алдаа»: a plain error card instead of a stack trace.
function ErrorFallback() {
  const { t } = useTranslation("profileForm");

  return (
    <Box className={classes.screen}>
      <Box w="100%" maw={420}>
        <StateCard
          role="alert"
          tone="error"
          size="md"
          titleOrder={1}
          icon={<ExclamationMarkIcon size={22} weight="bold" />}
          title={t("states.errorTitle", { defaultValue: "Мэдээлэл ачаалсангүй" })}
          description={t("states.errorText", { defaultValue: "Холболтоо шалгаад дахин оролдоно уу. Давтагдвал админд хандана уу." })}
          actions={
            <>
              <Button color="brand" radius="md" size="sm" onClick={() => window.location.reload()}>
                {t("states.retry", { defaultValue: "Дахин оролдох" })}
              </Button>
              {/* `?logout` clears the stored session first (app.tsx), so a broken
                  session cannot bounce the user straight back here. */}
              <Button component="a" href={`${basePath()}/login?logout`} variant="default" radius="md" size="sm">
                {t("states.toLogin", { defaultValue: "Нэвтрэх рүү" })}
              </Button>
            </>
          }
        />
      </Box>
    </Box>
  );
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Kept for diagnosis; the user sees the card above.
    console.error(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) return <ErrorFallback />;
    return this.props.children;
  }
}
